import * as React from 'react';
import { styled } from '../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface DropdownItem {
  label: string;
  enabled?: boolean;
  icon?: IconProp;
  action?: (e: React.MouseEvent) => any;
}

export interface DropdownWidgetProps {
  forwardRef?: React.MutableRefObject<any>;
  items: DropdownItem[];
}

export const DropdownWidget: React.FC<DropdownWidgetProps> = (props) => {
  const hasIcons = props.items.find((i) => !!i.icon);
  return (
    <S.Container ref={props.forwardRef}>
      {props.items.map((i, index) => {
        const length = props.items.length;
        const enabled = i.enabled ?? true;
        return (
          <S.Item
            key={`item-${index}`}
            onClick={(event) => {
              if (enabled) {
                i.action?.(event);
              }
            }}
            bottomBorder={index < length - 1}
          >
            <S.ItemContent enabled={enabled}>
              {hasIcons ? i.icon ? <S.Icon icon={i.icon!} /> : <S.IconPlaceholder /> : null}
              <S.Label>{i.label}</S.Label>
            </S.ItemContent>
          </S.Item>
        );
      })}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 3px;
    border: ${(p) => `1px solid ${p.theme.forms.ruler}`};
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.05);
    user-select: none;
    cursor: pointer;
    overflow: hidden;
  `;

  export const Label = styled.div`
    font-size: 16px;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    width: 15px;
  `;

  export const IconPlaceholder = styled.div`
    width: 15px;
  `;

  export const ItemContent = styled.div<{ enabled: boolean }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    cursor: ${(p) => (p.enabled ? 'pointer' : 'not-allowed')};
    color: ${(p) => p.theme.text.secondary};
    opacity: ${(p) => (p.enabled ? 1 : 0.3)};

    &:hover {
      color: ${(p) => p.theme.text.primary};
    }
  `;

  export const Item = styled.div<{ bottomBorder: boolean }>`
    flex-grow: 1;
    min-width: 120px;
    max-width: 200px;
    padding: 12px;
    background-color: ${(p) => p.theme.header.backgroundDarker};
    border-bottom: ${(p) => (p.bottomBorder ? `1px solid ${p.theme.forms.ruler}` : '')};
  `;
}
